import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import {
  Tabs,
  Tab,
  Typography,
  Chip,
  Button,
  CircularProgress,
  Paper
} from '@material-ui/core'
import GroupsTab from './GroupsTab'
import ItemsTab from './ItemsTab'
import MappingTab from './MappingTab'
import ExportPreviewTab from './ExportPreviewTab'

const STATUS_CHIP_PROPS = {
  parsing: { color: 'default', label: 'Parsing' },
  parsed: { color: 'primary', label: 'Parsed' },
  review_needed: { color: 'secondary', label: 'Review Needed', style: { backgroundColor: '#f57c00', color: '#fff' } },
  parse_failed: { color: 'secondary', label: 'Parse Failed' },
  mapped: { color: 'primary', label: 'Mapped' }
}

const TAB_LABELS = ['Groups', 'Items', 'Mapping', 'Export Preview']

const BidResponseWorkspace = ({ projectId, packageId, url }) => {
  const [pkg, setPkg] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [tab, setTab] = useState(0)

  const fetchPackage = useCallback(() => {
    setLoading(true)
    setError('')
    axios.get(`${url}/api/bid-estimation/bid-packages/${packageId}`)
      .then(res => {
        setPkg(res.data)
        setLoading(false)
      })
      .catch(err => {
        setError(err.response?.data?.message || 'Failed to load bid package.')
        setLoading(false)
      })
  }, [packageId, url])

  useEffect(() => {
    if (!packageId) return
    fetchPackage()
  }, [packageId, fetchPackage])

  const handleExport = () => {
    window.location = url + '/api/bid-estimation/bid-packages/' + packageId + '/export'
  }

  const getStatusChipProps = (status) => {
    return STATUS_CHIP_PROPS[status] || { color: 'default', label: status || 'Unknown' }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Typography color="error">{error}</Typography>
      </div>
    )
  }

  const statusProps = getStatusChipProps(pkg && pkg.status)

  return (
    <div style={{ padding: 24 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <Typography variant="caption" color="textSecondary">
            Bid Response
          </Typography>
          <Typography variant="h6">
            {pkg ? pkg.name : packageId}
          </Typography>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Chip
            label={statusProps.label}
            color={statusProps.color}
            size="small"
            style={statusProps.style || {}}
          />
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleExport}
          >
            Export
          </Button>
        </div>
      </div>

      {/* Tabs */}
      <Paper>
        <Tabs
          value={tab}
          onChange={(e, newVal) => setTab(newVal)}
          indicatorColor="primary"
          textColor="primary"
        >
          {TAB_LABELS.map((label, i) => (
            <Tab key={i} label={label} />
          ))}
        </Tabs>

        <div style={{ padding: 24 }}>
          {tab === 0 && <GroupsTab groups={pkg ? pkg.groups : []} onGroupUpdate={fetchPackage} url={url} />}
          {tab === 1 && <ItemsTab packageId={packageId} url={url} onItemUpdate={fetchPackage} />}
          {tab === 2 && <MappingTab packageId={packageId} url={url} onMappingUpdate={fetchPackage} />}
          {tab === 3 && <ExportPreviewTab packageId={packageId} url={url} />}
        </div>
      </Paper>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url
})

export default connect(mapStateToProps)(BidResponseWorkspace)
